import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

export const MergeAnimation = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    if (isInView) {
      const t1 = setTimeout(() => setPhase(1), 200);
      const t2 = setTimeout(() => setPhase(2), 1000);
      return () => { clearTimeout(t1); clearTimeout(t2); };
    }
  }, [isInView]);

  return (
    <div ref={ref} className="py-12 md:py-16 bg-card border-y border-border">
      <div className="container-wide">
        <div className="flex items-center gap-8">
          {/* Left label */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.4 }}
            className="hidden md:block shrink-0"
          >
            <p className="text-[10px] font-heading uppercase tracking-widest text-muted-foreground">3 Unternehmen</p>
          </motion.div>

          {/* SVG Animation */}
          <div className="flex-1 relative h-16 md:h-20">
            <svg className="w-full h-full" viewBox="0 0 1200 80" preserveAspectRatio="none">
              <motion.path
                d={phase >= 2 ? "M0,15 C400,15 800,40 1200,40" : "M0,15 C400,15 600,15 1200,15"}
                fill="none"
                stroke="hsl(215, 75%, 50%)"
                strokeWidth="2.5"
                initial={{ pathLength: 0, opacity: 0 }}
                animate={isInView ? { pathLength: 1, opacity: 1 } : {}}
                transition={{ duration: 0.8, delay: 0.1, ease: "easeInOut" }}
              />
              <motion.path
                d="M0,40 C400,40 600,40 1200,40"
                fill="none"
                stroke="hsl(25, 85%, 55%)"
                strokeWidth="2.5"
                initial={{ pathLength: 0, opacity: 0 }}
                animate={isInView ? { pathLength: 1, opacity: 1 } : {}}
                transition={{ duration: 0.8, delay: 0.3, ease: "easeInOut" }}
              />
              <motion.path
                d={phase >= 2 ? "M0,65 C400,65 800,40 1200,40" : "M0,65 C400,65 600,65 1200,65"}
                fill="none"
                stroke="hsl(152, 55%, 42%)"
                strokeWidth="2.5"
                initial={{ pathLength: 0, opacity: 0 }}
                animate={isInView ? { pathLength: 1, opacity: 1 } : {}}
                transition={{ duration: 0.8, delay: 0.5, ease: "easeInOut" }}
              />
              {phase >= 2 && (
                <motion.circle
                  cx="1200" cy="40" r="5"
                  fill="hsl(210, 20%, 93%)"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.3, delay: 0.2 }}
                />
              )}
            </svg>
          </div>

          {/* Right label */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={phase >= 2 ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.4, delay: 0.3 }}
            className="shrink-0 text-right"
          >
            <p className="font-heading font-bold text-sm md:text-base text-foreground uppercase tracking-wider">
              Freitag-Gruppe
            </p>
            <p className="text-[10px] text-muted-foreground font-body">Vereinte Stärke</p>
          </motion.div>
        </div>
      </div>
    </div>
  );
};
